import React, { useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import * as actionType from '../context/actions';
import { ConfigContext } from "../context/GlobalContext";

const GuestLoginSuggestionModal = () => {
    const { state, dispatch } = useContext(ConfigContext);

    const handleClose = () => {
        dispatch({ type: actionType.GUESTMODELPOPUP, payload: false });
    }

    return (
        <Modal show={!state?.USERID && state?.GUESTMODELPOPUP} onHide={handleClose} centered dialogClassName="wide-modal">
            <div className="text-center px-3 py-3">
                <Modal.Header closeButton className="border-0 justify-content-center pb-1" />

                <Modal.Body className="text-muted p-5 pt-3">
                    <h5 className="fw-bold mb-5 text-secondary-light">
                        Please login first
                    </h5>

                    <div className="d-flex justify-content-center mt-2 mb-4">
                        <div className="bg-primary-50 radius-circle d-flex align-items-center justify-content-center" style={{ width: '120px', height: '120px' }}>
                            <Icon
                                icon="solar:user-block-bold-duotone"
                                className="text-primary-600"
                                style={{ fontSize: "5rem" }}
                            />
                        </div>
                    </div>

                    <p className="mb-1 text-secondary-light">
                        You need to be logged in to access features or create new data.
                    </p>
                    <p className="mb-5 text-secondary-light">
                        Login now to securely manage your business and save your records.
                    </p>

                    <div className="d-flex flex-column gap-3">
                        <Link onClick={handleClose} to="/login" className="w-100">
                            <Button
                                variant="primary"
                                className="w-100 fw-semibold py-2 shadow-sm"
                                style={{
                                    fontSize: "16px",
                                    borderRadius: "8px",
                                    height: 44,
                                }}
                            >
                                Login Now
                            </Button>
                        </Link>
                    </div>

                </Modal.Body>
            </div>
        </Modal>
    );
};

export default GuestLoginSuggestionModal;
